(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/campaign-flerp/assets/javascripts/campaign-flerp.js') >= 0) return;  svs.modules.push('/components/lb-ui/campaign-flerp/assets/javascripts/campaign-flerp.js');
"use strict";


const _svs$ui = svs.ui,
  ReactIcon = _svs$ui.ReactIcon,
  ReactButton = _svs$ui.ReactButton;
const CampaignStep = svs.components.lbUi.campaignStep.CampaignStep;
const CampaignFlerp = _ref => {
  let isLightMode = _ref.isLightMode,
    branding = _ref.branding,
    hideLink = _ref.hideLink;
  const _svs$lb_ui$campaign_f = svs.lb_ui.campaign_flerp.data.campaignFlerp,
    campaignIsAvailable = _svs$lb_ui$campaign_f.campaignIsAvailable,
    campaignUrl = _svs$lb_ui$campaign_f.campaignUrl,
    customerRegistration = _svs$lb_ui$campaign_f.customerRegistration,
    reward = _svs$lb_ui$campaign_f.reward,
    currentStepIndex = _svs$lb_ui$campaign_f.currentStepIndex,
    isStartPage = _svs$lb_ui$campaign_f.isStartPage;
  if (!campaignIsAvailable) {
    return null;
  }
  const isLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const steps = ['Bli kund', 'Sätt in', 'Spela', "F\xE5 ".concat(reward, " kr")];
  const Icon = () => React.createElement(ReactIcon, {
    color: "fc-".concat(isLightMode ? 'navy' : 'white'),
    icon: "game-package",
    size: "500"
  });
  return React.createElement("div", {
    className: "campaign-flerp".concat(isLightMode ? ' campaign-flerp-light' : '', " padding campaign-flerp-").concat(branding || 'default', " f-500")
  }, React.createElement("div", {
    className: "campaign-flerp-text-container"
  }, React.createElement(Icon, null), React.createElement("span", {
    className: "campaign-flerp-text f-left ".concat(isLoggedIn ? '' : 'campaign-flerp-text-single-line')
  }, "Bli kund och f\xE5 ".concat(reward, " kr att spela f\xF6r. "), isLoggedIn && " Pengarna betalas ut vid avgjort spel. ", !hideLink && React.createElement("a", {
    className: "campaign-flerp-link f-medium",
    href: campaignUrl
  }, " L\xE4s mer")), !isStartPage && !isLoggedIn && React.createElement(ReactButton, {
    className: "campaign-flerp-button",
    href: customerRegistration || '/skapa-inloggning',
    size: 300
  }, "Bli kund")), isLoggedIn && React.createElement("div", {
    className: "campaign-step-container"
  }, React.createElement(CampaignStep, {
    branding: branding,
    currentStepIndex: currentStepIndex,
    steps: steps
  })));
};
setGlobal('svs.components.lbUi.campaignFlerp.CampaignFlerp', CampaignFlerp);

 })(window);